import classifications from './classifications';

export default {
  classifications,
}